module.exports = __webpack_public_path__ + "static/img/medal2.608e03e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/6/medal2.png
// module id = BKR0
// module chunks = 1